import React from "react";
import { isMobileOnly } from "react-device-detect";

interface ImgFullScreenProps {
  captionArray?: string[];
  url?: string;
  elementId?: string;
  imgMarginTop?: string;
  imgHeight?: string;
}

const ImgFullScreen: React.FC<ImgFullScreenProps> = ({
  captionArray,
  url,
  elementId = "",
  imgMarginTop = "mb--40",
  imgHeight = "100vh",
}) => (
  <div
    id={elementId}
    className={`${imgMarginTop}`}
    data-black-overlay="2"
    style={
      url
        ? {
            backgroundImage: `url(${url})`,
            height: `${imgHeight}`,
            backgroundAttachment: `${isMobileOnly ? "scroll" : "fixed"}`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }
        : {}
    }
  >
    {Array.isArray(captionArray) && captionArray.length === 2 ? (
      <div className="centered">
        <p className="mb--80">{captionArray[0]} </p>
        <p>{captionArray[1]}</p>
      </div>
    ) : (
      ""
    )}

    {captionArray &&
      Array.isArray(captionArray) &&
      captionArray.length === 1 && (
        <h1 className="centered">{captionArray[0]} </h1>
      )}
  </div>
);

export default ImgFullScreen;
